import {
    call,
    takeEvery
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* chargeDetailsFromLastSimilarPayment(action: ActionInterface): any {
  try {
    let request = `charges/details`;

		const res = yield call(Http.post, request, {...action.payload});

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, {
        typeId: res?.data?.type,
        contractId: res?.data?.contractId,
        unitId: res?.data?.unitId,
        propertyId: res?.data?.propertyId,
        ownerId: res?.data?.ownerId,
        contactId: res?.data?.contactId,
        companyId: res?.data?.companyId,
      });
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchChargeDetailsFromLastSimilarPayment() {
  yield takeEvery(Constants.GLOBAL_CHARGE_DETAILS_FROM_LAST_SIMILAR_PAYMENT, chargeDetailsFromLastSimilarPayment);
}
